import React from 'react';
import type { PageTitleProps } from './types';

export const PageTitle: React.FC<PageTitleProps> = ({ children, 'data-testid': testId }) => (
    <h1 className="text-page-title text-content" data-testid={testId}>
        {children}
    </h1>
);
